import React, { Suspense } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/auth";
import { Navigate } from "react-router-dom";
import AppSidebar from "./AppSidebar";
import AppTopbar from "./AppTopbar";
import {
  SidebarProvider,
  SidebarInset,
} from "@/components/ui/sidebar";
import PageObserver from "../Translation/PageObserver";

const AppLayout: React.FC = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="animate-spin h-8 w-8 border-t-2 border-b-2 border-primary rounded-full" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <SidebarInset>
          <AppTopbar />
          <main className="flex-1 p-4 md:p-6 lg:p-8 overflow-auto">
            <Suspense
              fallback={
                <div className="flex items-center justify-center min-h-[50vh]">
                  <div className="animate-spin h-8 w-8 border-t-2 border-b-2 border-primary rounded-full" />
                </div>
              }
            >
              <Outlet />
            </Suspense>
          </main>
        </SidebarInset>
      </div>
      <PageObserver />
    </SidebarProvider>
  );
};

export default AppLayout;
